/*
 * Branches service
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2021 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Constants } from 'app/shared/config/constants';
import { Observable } from 'rxjs';
import { Branch } from 'app/shared/models';

@Injectable ( {
  providedIn: 'root'
} )
export class BranchService {
  readonly url = Constants.branchesUrl;

  constructor( private http: HttpClient ) {
  }

  search( incidentId: number, searchTerm: string ): Observable<Branch[]> {
    const params = new HttpParams ().appendAll ( { incidentId, searchTerm } );
    return this.http.get<Branch[]> ( this.url, { params } );
  }
}
